import * as React from "react";

const Header: React.FC<{text: string}> = ({text}) => {
    return (
        <div className="font-bold text-menu text-xl mb-2">{text}</div>
    )
}

export default Header;